import './Login2FA.scss';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { resendOTP } from '../../store/apis/userService';

function ResendOTP({ setTimer, disabled }) {
  const { mutate: resend, isPending } = useMutation({
    mutationFn: resendOTP,
  });
  const { mutate: resendMobile, isPendingMobile } = useMutation({
    mutationFn: resendOTP,
  });

  const handleResend = () => {
    resend(
      {
        userId: localStorage.getItem('2FAUserId'),
        email: localStorage.getItem('2FAEmail'),
        mobile: localStorage.getItem('2FAMobile'),
        type: 'email',
      },
      {
        onSuccess: () => {
          toast.success('OTP resent successfully!', {
            className: 'toast-success',
          });
          setTimer(process.env.REACT_APP_OTP_RESEND_TIMEOUT || 60); // Reset the timer to 30 seconds
        },
        onError: err => {
          toast.error(err.message ?? err.error ?? 'Failed to resend OTP', {
            className: 'toast-error',
          });
        },
      },
    );
  };

  const handleResendMobile = () => {
    resendMobile(
      {
        userId: localStorage.getItem('2FAUserId'),
        email: localStorage.getItem('2FAEmail'),
        mobile: localStorage.getItem('2FAMobile'),
        type: 'mobile',
      },
      {
        onSuccess: () => {
          toast.success('OTP sent successfully!', {
            className: 'toast-success',
          });
          setTimer(process.env.REACT_APP_OTP_RESEND_TIMEOUT || 60); // Reset the timer to 30 seconds
        },
        onError: err => {
          toast.error(err.message ?? err.error ?? 'Failed to resend OTP', {
            className: 'toast-error',
          });
        },
      },
    );
  };

  return (
    <div className="resend-otp">
      <div className="d-flex flex-row align-items-center gap-1">
        <span className="resend-text">If you didn&apos;t receive a code -</span>
        <button
          className="resend-btn"
          type="button"
          disabled={isPending || disabled}
          onClick={!isPending && !disabled ? handleResend : undefined}
        >
          {isPending ? 'Resending...' : 'Resend'}
        </button>
      </div>

      <div>
        <strong>OR</strong>
      </div>
      <button
        className="resend-btn"
        type="button"
        disabled={isPendingMobile || disabled}
        onClick={!isPendingMobile && !disabled ? handleResendMobile : undefined}
      >
        {isPendingMobile ? 'Sending...' : '(Send OTP via SMS)'}
      </button>
      {/* <span
        className="resend-btn"
        disabled={isPending || disabled}
        style={{
          cursor: isPending || disabled ? 'not-allowed' : 'pointer',
          opacity: isPending || disabled ? 0.6 : 1,
        }}
        onClick={!isPending ? handleResend : undefined}
      >
        {isPending ? 'Resending...' : 'Resend'}
      </span> */}
    </div>
  );
}

export default ResendOTP;
